<template>
    <v-list dense> 
        <v-list-tile active-class="primary darken-2" @click="switchTenant(tenant)" avatar v-for="tenant of tenants" :key="tenant.id">
            <v-list-tile-avatar> <i class="far fa-window-restore"></i>  </v-list-tile-avatar>                      
            <v-list-tile-title>{{tenant.name}}</v-list-tile-title>     
            <i v-if="tenant.id == user.tenant.id" class="fas fa-check"></i>
        </v-list-tile>                  
    </v-list>   
</template>

<script>
    import { unauthenticated } from "../../plugins/core/dd.data.connect"
    import * as types from '../../store/types'    
    export default {
        props:['tenants','user'],
        methods: {            
            switchTenant(tenant) {
                let vm = this;

                this.$store.dispatch(types.USER_SWITCH_TENANT, {data:{userId:vm.user.id,tenantId:tenant.id}}).then((res) => { 
                   this.$notify(`Gewisseld naar omgeving ${tenant.name}`, {type: 'success', icon: 'check'})                   
                   unauthenticated()
                }).catch((e) => {
                    this.$notify(`Wisselen naar omgeving ${tenant.name} niet toegestaan`, {type: 'error', icon: 'error'})
                })
            }
        }, 
        mounted(){    
        }
    }
</script>

<style scoped>
   
</style>